// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"747":"edbf249e","945":"bd564414"}[chunkId] + ".chunk.js";
};